import { render, staticRenderFns } from "./InformeVentas.vue?vue&type=template&id=1e3844e6&scoped=true"
import script from "./InformeVentas.vue?vue&type=script&lang=js"
export * from "./InformeVentas.vue?vue&type=script&lang=js"
import style0 from "./InformeVentas.vue?vue&type=style&index=0&id=1e3844e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3844e6",
  null
  
)

export default component.exports